import React from 'react';
import {
  useLocation, useNavigate, useParams
} from 'react-router-dom';

export function withRouter(Component) {
  return function(props) {
    return (
      <Component
        {...props}
        router={{
          location: useLocation(),
          navigate: useNavigate(),
          params: useParams(),
        }}
      />
    );
  };
}
